import { Button } from "react-bootstrap";
import { CustomInput } from "../../Common/Ui/CustomInput";
import { ChatMessage } from "./ChatMessage";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import enquiryscss from "../../../sass/enquiry-list/Enquiry.module.scss";
import { TChatMessage } from "../../../interfaces/enquiry.interface";
import { DocumentUploadModal } from "./DocumentUploadModal";

type TTabDetail = {
  tabName: string;
  tabKey?: string;
};

export const CommonChatComponent: React.FC<{
  selectedTab: string;
  onTabChange: (tabDetails?: TTabDetail) => void;
  chatTabDetails: Array<{
    tabKey: string;
    tabName: string;
    messages: TChatMessage[];
  }>;
  sendMsg: (msg: string) => void;
  getMessages: (tabDetails?: TTabDetail) => void;
  showUploadDocumentButton?: boolean;
  onDocumentUpload?: (formData: FormData) => Promise<void>;
}> = (props) => {
  const [chatMsg, setChatMsg] = useState("");

  const [showChat, setShowChat] = useState(false);
  const chatContainerRef = useRef<HTMLDivElement>(null);

  const [showUploadDocumentyModal, setShowUploadDocumentModal] =
    useState(false);

  // call get remarks api on every 5 seconds
  useEffect(() => {
    if (showChat) {
      const interval = setInterval(() => {
        props.getMessages();
      }, 5000);
      return () => clearInterval(interval);
    }
  });

  useEffect(() => {
    if (chatContainerRef?.current && showChat) {
      chatContainerRef.current?.scrollTo({
        behavior: "smooth",
        top: chatContainerRef.current.scrollHeight,
        left: 0,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    chatContainerRef?.current,
    showChat,
    props.chatTabDetails?.length,
    props.selectedTab,
  ]);

  return (
    <div
      className={`${showChat ? `${enquiryscss.chatBackdrop}` : ""}`}
      onClick={() => {
        setShowChat(false);
        props.onTabChange();
      }}
    >
      <div
        className={`${enquiryscss.chatContainer} d-flex align-items-end`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className={enquiryscss.openChatArrow}
          style={{
            display: showChat ? "none" : "block",
          }}
          onClick={(e) => {
            // if (!chatWithOpt.staff && !chatWithOpt.customer) {
            //   setChatWithOpt({
            //     customer: true,
            //     staff: false,
            //   });
            // }
            setShowChat(true);
          }}
        >
          <i className="fas fa-chevron-circle-up"></i>
        </div>

        {showChat && (
          <div className={`${enquiryscss.chatBtns} d-flex`}>
            {props.chatTabDetails.map((tab) => {
              return (
                <button
                  key={tab.tabName}
                  className={`small btn btn-sm rounded-0 ${
                    tab.tabName === props.selectedTab
                      ? "btn-outline-primary"
                      : "btn-primary"
                  }`}
                  onClick={() => {
                    props.onTabChange({
                      tabName: tab.tabName,
                      tabKey: tab.tabKey,
                    });
                  }}
                >
                  {tab.tabName}
                </button>
              );
            })}
          </div>
        )}

        <div className="container">
          {showChat &&
            props.chatTabDetails.map((singleTabDetails) => {
              if (singleTabDetails.tabName !== props.selectedTab) {
                return null;
              }
              return (
                <div
                  key={singleTabDetails.tabName}
                  className={`${enquiryscss.scrollChat} px-3 ${
                    showChat
                      ? `${enquiryscss.visible}`
                      : `${enquiryscss.hidden}`
                  }`}
                  ref={chatContainerRef}
                >
                  {singleTabDetails.messages?.length ? (
                    singleTabDetails.messages?.map((messageDetail, index) => {
                      let shoWDate = false;
                      if (
                        singleTabDetails.messages &&
                        singleTabDetails.messages[index + 1]
                      ) {
                        shoWDate =
                          moment(messageDetail.createdAt).date() <
                          moment(
                            singleTabDetails.messages[index + 1].createdAt
                          ).date();
                      }

                      return (
                        <div
                          key={`chat-msg-${index}`}
                          className={enquiryscss.chatMsgContainer}
                        >
                          {index === 0 && (
                            <div className={enquiryscss.dateBlock}>
                              <span>
                                {new Date().getDate() ===
                                moment(messageDetail.createdAt).date()
                                  ? "today"
                                  : moment(messageDetail.createdAt).format(
                                      "ll"
                                    )}
                              </span>
                            </div>
                          )}
                          <ChatMessage messageDetails={messageDetail} />
                          {shoWDate && (
                            <div className={enquiryscss.dateBlock}>
                              <span>
                                {new Date().getDate() ===
                                moment(
                                  singleTabDetails.messages![index + 1]
                                    .createdAt
                                ).date()
                                  ? "today"
                                  : moment(
                                      singleTabDetails.messages![index + 1]
                                        .createdAt
                                    ).format("ll")}
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <span className="d-flex justify-content-center">
                      Start Conversation...
                    </span>
                  )}
                </div>
              );
            })}

          <form className="row mt-4 px-1">
            <div className="col-lg-10 col-8 ps-0">
              <CustomInput
                onChange={(e) => {
                  setChatMsg(e.target.value);
                }}
                className={enquiryscss.chatInput}
                placeholder="Write your message...."
                value={chatMsg}
                onFocus={(e) => {
                  setShowChat(true);
                }}
              />
            </div>

            <Button
              className={`col-lg-1 col-2 ${enquiryscss.sendBtn}`}
              disabled={!showChat || !chatMsg}
              type="submit"
              onClick={async (e) => {
                e.preventDefault();
                setShowChat(true);
                if (showChat) {
                  setChatMsg("");
                  props.sendMsg(chatMsg);
                }
              }}
            >
              <i className="fa-solid fa-paper-plane"></i>
            </Button>

            {props.showUploadDocumentButton && (
              <div className="col-lg-1 col-2">
                <Button
                  className={enquiryscss.sendBtn}
                  onClick={() => {
                    setShowUploadDocumentModal(true);
                  }}
                >
                  <i className="fa-solid fa-upload"></i>
                </Button>
              </div>
            )}
          </form>
        </div>

        {props.showUploadDocumentButton &&
          props.onDocumentUpload &&
          showUploadDocumentyModal && (
            <DocumentUploadModal
              onClose={() => {
                console.log(showUploadDocumentyModal);
                setShowUploadDocumentModal(false);
              }}
              show={showUploadDocumentyModal}
              onUpload={props.onDocumentUpload}
            />
          )}
      </div>
    </div>
  );
};
